module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers clearfix",
    attrs: {
      "id": "pers-salary",
      "name": "hres8ax-salary"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "income-summary-box"
  }, [_c('div', {
    staticClass: "label-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC1']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "income color-skin"
  }, [_vm._v(_vm._s(_vm.detailSalary.amtsalyr) + " " + _vm._s(_vm.labels['HRES8AXC1']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "vat-box clearfix"
  }, [_c('div', {
    staticClass: "label-vat"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC1']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "vat color-skin"
  }, [_vm._v(_vm._s(_vm.detailSalary.amttaxt) + " " + _vm._s(_vm.labels['HRES8AXC1']['80']))])])]), _vm._v(" "), _c('div', {
    staticClass: "cal-input-group clearfix"
  }, [_c('div', {
    staticClass: "cal-topic color-skin clearfix"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC1']['40']) + " " + _vm._s(_vm.detailSalary.dteyrepay))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 "
  }, [_c('div', {
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC1']['50']))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-input clear-padding"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.detailSalary.amtincom1))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC1']['30']))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-input clear-padding"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.detailSalary.amttaxt))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC1']['60']))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-input clear-padding"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.detailSalary.amtsalt))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC1']['70']))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-input clear-padding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailSalary.amtothyr),
      expression: "detailSalary.amtothyr"
    }],
    staticClass: "form-control input-text",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "id": "amtothyr",
      "name": "amtothyr"
    },
    domProps: {
      "value": (_vm.detailSalary.amtothyr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailSalary, "amtothyr", $event.target.value)
      }
    }
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27cc4299!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres8ax/salary.vue
// module id = 3641
// module chunks = 1